module.exports = __webpack_public_path__ + "img/mile1-m@2.16088d97.jpg";